import { View, Text } from 'react-native';
import { useRouter } from 'expo-router';
import { Button } from './Button';
import { WebHead } from './WebHead';
import { supabase } from '../lib/supabase';

export function SubscriptionAccessGate({ expiresAt }: { expiresAt?: string | null }) {
  const router = useRouter();
  const formattedDate = expiresAt
    ? new Date(expiresAt).toLocaleDateString(undefined, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      })
    : null;

  return (
    <View className="flex-1 bg-canvas dark:bg-canvas-dark px-4 py-8">
      <WebHead><title>Subscribe to Continue – Per Diem</title></WebHead>
      <View className="mx-auto w-full max-w-[520px] flex-1 justify-center gap-6">
        <View className="gap-3">
          <Text className="text-3xl font-bold text-gray-900 dark:text-gray-100">
            Subscribe to continue using Per Diem
          </Text>
          <Text className="text-base leading-7 text-gray-600 dark:text-gray-300">
            {formattedDate
              ? `Your trial or subscription ended on ${formattedDate}, so app access and live account sync are paused.`
              : 'Your trial or subscription has ended, so app access and live account sync are paused.'}
            {' '}Your imported data and plan are still saved.
          </Text>
          <Text className="text-base leading-7 text-gray-600 dark:text-gray-300">
            Subscribe to restore access, reconnect your accounts, and keep your daily spending number and FIRE plan current.
          </Text>
        </View>

        <View className="gap-3">
          <Button
            onPress={() => {
              router.replace('/(app)/settings');
            }}
          >
            Subscribe in Settings
          </Button>
          <Button
            variant="ghost"
            onPress={() => {
              void supabase.auth.signOut();
            }}
          >
            Sign out
          </Button>
        </View>
      </View>
    </View>
  );
}
